<template>
  <div class="dao-container">
    <van-popup v-model="showBottom" position="bottom" round class="popup" style="padding: 40px 32px;">
      <div class="pop_title">{{ $t('lang.swap525') }}</div>
      <div class="pop_num">
        <span style="font-size: 36px;">{{ config_dao.pledge_amount }}</span>
        <span style="font-size: 14px;"> VRT</span>
      </div>
      <div class="pop_wallet">
        <img style="margin-right: 7px;" src="@/assets/img/wallet_icon.svg" alt="">
        <span>{{ $t('lang.swap526') }}:</span>
        <span>{{ balance }}</span>
      </div>
      <div class="button_box1">
        <button @click="daoholdpledge">
          <van-loading color="#FFFFFF" v-if="daoLoading"></van-loading>
          <span v-else>{{ $t('lang.swap527') }}</span>

        </button>
      </div>
    </van-popup>
    <div class="header-banner">
      <h2 class="title">{{ $t("lang.swap529") }}</h2>
      <div class="banner-img-placeholder">
        <img src="@/assets/img/node_buy_2.webp" alt="banner" />
      </div>
    </div>

    <div class="stat-cards-wrapper">
      <div class="card-group">
        <div class="card card-blue">
          <div class="card-content">
            <div class="label">
              <img src="@/assets/img/node_icon1.png" class="icon" />
              {{ $t("lang.swap530") }}
            </div>
            <div class="value">{{ daoInfo.total || 0 }}</div>
          </div>
        </div>

        <div class="card card-cyan">
          <div class="card-content">
            <div class="label">
              <img src="@/assets/img/node_icon2.png" class="icon" />
              {{ $t("lang.swap531") }}
            </div>
            <div class="value">{{ daoInfo.release || 0 }}</div>
          </div>
        </div>
      </div>
    </div>

    <section class="section">
      <h3 class="section-title">{{ $t("lang.swap532") }}</h3>
      <div class="node-types">
        <div v-for="node in configs_dao" :key="node.id" :class="['node-item', { active: config_dao.id === node.id }]"
          @click="selectedNode(node)">
          <span class="radio-circle"></span>
          {{ $t(node.name) }}
        </div>
      </div>
    </section>

    <section class="section">
      <h3 class="section-title">{{ $t("lang.swap533") }}</h3>
      <div class="pay-input-wrapper">
        <div class="pay-inner">
          <div class="pay-icon">
            <img src="@/assets/img/VRT.png" alt="">
          </div>
          <span class="pay-amount">{{ config_dao.pledge_amount }}</span>
        </div>
      </div>
      <div class="balance-info">
        {{ $t("lang.swap534") }}：<span>{{ balance }} VRT</span>
      </div>
    </section>
    <div class="upgrade">
      <button class="upgrade-btn" @click="showBottom = true">{{ $t("lang.swap535") }}</button>
    </div>


    <div class="record-container">
      <div class="tabs">
        <span class="tab" :class="tabactive == 0 ? 'active' : ''" @click="tabactive = 0">{{ $t("lang.swap536") }}</span>
        <span class="tab" :class="tabactive == 1 ? 'active' : ''" @click="tabactive = 1">{{ $t("lang.swap537") }}</span>
      </div>
      <van-list v-show="billInfo_0.list.length > 0 && tabactive == 0" v-model:loading="billInfo_0.loading"
        :finished="billInfo_0.finished" :finished-text="$t('lang.swap538')" @load="onLoad_0">
        <div class="table-wrapper">
          <table class="record-table">
            <thead>
              <tr>
                <th style="justify-content: left;">{{ $t("lang.swap539") }}</th>
                <th style="justify-content: center;">{{ $t("lang.swap540") }}</th>
                <th style="justify-content: right;">{{ $t("lang.swap541") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in billInfo_0.list" :key="index">
                <td style="justify-content: left;">{{ item.created_at }}</td>
                <td style="justify-content: center;">{{ item.conf_name }}</td>
                <td style="justify-content: right;">{{ item.pay_amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </van-list>
       <van-list v-show="billInfo_1.list.length > 0 && tabactive == 1" v-model:loading="billInfo_1.loading"
        :finished="billInfo_1.finished" :finished-text="$t('lang.swap538')" @load="onLoad_1">
        <div class="table-wrapper">
          <table class="record-table">
            <thead>
              <tr>
                <th style="justify-content: left;">{{ $t("lang.swap539") }}</th>
                <th style="justify-content: right;">{{ $t("lang.swap545") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in billInfo_0.list" :key="index">
                <td style="justify-content: left;">{{ item.created_at }}</td>
                <td style="justify-content: right;">{{ item.usable_change }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </van-list>


    </div>
  </div>
</template>

<script>
import Web3 from 'web3';
import { usApi, newsLetterApi, walletApi } from '@/api/index';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      nodeTypes: [
        { id: 1, name: 'lang.swap542' },
        { id: 2, name: 'lang.swap543' },
        { id: 3, name: 'lang.swap544' }
      ],
      billInfo_0: {
        list: [],
        loading: false,
        finished: false,
        params: {
          page: 1,
          page_size: 10,
        }
      },
       billInfo_1: {
        list: [],
        loading: false,
        finished: false,
        params: {
          page: 1,
          page_size: 10,
          behavior: 1,
        }
      },
      configs_dao: [],
      config_dao: {
        id: 0
      },
      balance: 0,
      showBottom: false,
      daoLoading: false,
      tabactive: 0,
      daoInfo: {},
    };
  },
  computed: {
    ...mapState(['account']),
  },
  watch: {
    account() {
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.account) {
        this.daoconfig();
        this.getWalletInfo();
        this.initbillInfo_0();
        this.initbillInfo_1();
        this.daowalletinfo();
      }
    },
    selectedNode(node) {
      this.config_dao = node;
    },
    onLoad_0() {
      this.getbillInfo_0();
    },
    initbillInfo_0() {
      this.billInfo_0 = {
        list: [],
        loading: false,
        finished: false,
        params: {
          page: 1,
          page_size: 10,
        }
      }
      this.getbillInfo_0()
    },
    getbillInfo_0() {

      this.billInfo_0.loading = true
      walletApi.daoholdlist(this.billInfo_0.params, this.account).then((res) => {
        if (res.data.list && res.data.list.length > 0) {
          if (this.billInfo_0.params.page == 1) {
            this.billInfo_0.list = res.data.list
          } else {
            this.billInfo_0.list = this.billInfo_0.list.concat(res.data.list)
          }
          if (res.data.list.length < this.billInfo_0.params.page_size) {
            this.billInfo_0.finished = true
          } else {
            this.billInfo_0.params.page += 1
          }
        } else {
          this.billInfo_0.finished = true;
        }
        this.billInfo_0.loading = false;
      }).catch(() => {
        this.billInfo_0.loading = false;
        this.billInfo_0.finished = true;

      })
    },
     onLoad_1() {
      this.getbillInfo_1();
    },
    initbillInfo_1() {
      this.billInfo_1 = {
        list: [],
        loading: false,
        finished: false,
        params: {
          page: 1,
          page_size: 10,
          behavior: 1,
        }
      }
      this.getbillInfo_1()
    },
    getbillInfo_1() {

      this.billInfo_1.loading = true
      walletApi.daowalletrecordlist(this.billInfo_1.params, this.account).then((res) => {
        if (res.data.list && res.data.list.length > 0) {
          if (this.billInfo_1.params.page == 1) {
            this.billInfo_1.list = res.data.list
          } else {
            this.billInfo_1.list = this.billInfo_1.list.concat(res.data.list)
          }
          if (res.data.list.length < this.billInfo_1.params.page_size) {
            this.billInfo_1.finished = true
          } else {
            this.billInfo_1.params.page += 1
          }
        } else {
          this.billInfo_1.finished = true;
        }
        this.billInfo_1.loading = false;
      }).catch(() => {
        this.billInfo_1.loading = false;
        this.billInfo_1.finished = true;

      })
    },

    async daoholdpledge() {
      if (this.daoLoading) return;
      this.daoLoading = true;
      let web3 = new Web3(window.ethereum);
      let sign = null;
      let signature_ts = Math.floor(Date.now() / 1000);
      try {
        sign = await web3.eth.personal.sign(web3.utils.fromUtf8(`Dao Pledge ${signature_ts}`), this.account)
      } catch (error) {
        this.daoLoading = false;
      }
      walletApi.daoholdpledge({ signature: sign, signature_ts: signature_ts, conf_id: this.config_dao.id }, this.account).then(res => {
        this.daoLoading = false;
        this.$toast(res.msg);
        if (res.code == 200) {
          this.showBottom = false;
          this.init();
        }
      })

    },
    daoconfig() {
      walletApi.daoconfigs(this.account).then(res => {
        if (res.code == 200) {
          let list = res.data;
          this.configs_dao = list.map((item, index) => {
            return {
              ...item,
              ...this.nodeTypes[index]
            }
          })
          this.config_dao = this.config_dao.id != 0 ? this.config_dao : this.configs_dao[0];
          console.log(this.configs_dao, this.config_dao);

        }

      })
    },
    getWalletInfo() {
      walletApi.getWalletInfo({ token_id: 2 }, this.account).then(res => {
        if (res.code == 200) {
          this.balance = res.data.usable;
        }

      })
    },
    daowalletinfo() {
      walletApi.daowalletinfo(this.account).then(res => {
        if (res.code == 200) {
          this.daoInfo = res.data;
        }

      });
    }
  }
};
</script>

<style lang="less" scoped>
// 变量定义
@bg-color: #000000;
@card-dark: #1a1f2e;
@primary-cyan: #26a9bb;
@primary-blue: #1c3d82;
@text-gray: #a0a0a0;

.dao-container {
  background-color: @bg-color;
  color: #ffffff;
  min-height: 100vh;
  padding: 20px;
  padding-bottom: 100px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  .header-banner {
    text-align: center;
    padding-bottom: 20px;

    .title {
      font-size: 20px;
      margin-bottom: 20px;
      font-weight: 500;
    }

    .banner-img-placeholder img {
      width: 100%;
      max-width: 350px;
      border-radius: 12px;
    }
  }

  // 数据卡片布局
  .stat-cards-wrapper {
    // 增加一点内边距，防止 clip-path 切到父级
  }

  .card-group {
    display: flex;
    // 使用负 margin 让右侧卡片左移，从而与左侧斜角“咬合”
    // 这个值（-20px）大约是斜角的水平宽度，需要和 clip-path 的定义相匹配

    // 给整体加一个圆角效果的容器（可选，图中看起来边缘是圆润的）
    // 注意：clip-path 剪裁后的边缘是直角的，要实现圆润的切角比较复杂，
    // 这里采用最接近原图的直角剪裁，让整体布局看起来是对称的。
  }

  .card {
    width: 52%;
    flex-shrink: 0;
    height: 75px;
    position: relative;
    color: #ffffff;

    // 内部内容布局
    .card-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;

      .label {
        font-size: 13px;
        opacity: 0.9;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 10px; // 根据实际图标位置微调

        .icon {
          width: 16px;
          height: 16px;
          margin-right: 6px;
          // 图标颜色微调，可以使用 filter: drop-shadow(0 0 1px #fff); 增加点发光感
        }
      }

      .value {
        font-size: 18px;
        font-weight: 700;
        padding-left: 10px;
        font-family: Arial, sans-serif; // 还原图中数字字体
      }
    }

    // 左侧蓝色卡片专用样式 (右下切斜)
    &.card-blue {
      background: linear-gradient(129.77deg, rgba(21, 68, 176, 1) 0%, rgba(13, 43, 112, 0.47) 100%);
      ;
      // 定义 clip-path 多边形定点 (左上, 右上, 右下(切斜开始), 左下)
      // (100% 80%, 100% 80%) 这两个点定义了右下角的斜切面
      clip-path: polygon(0 0, 100% 0, 100% 0%, 80% 100%, 0 100%);
      border-radius: 6px;

      // 内部内容整体往左移，避免靠近切角
      .card-content {
        padding-right: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }
    }

    // 右侧青色卡片专用样式 (左上切斜)
    &.card-cyan {
      margin-left: -4%;
      background: linear-gradient(-70deg, rgba(0, 51, 48, 1) 0%, rgba(45, 174, 179, 1) 100%);
      ;
      // 定义 clip-path 多边形定点 (左上(切斜结束), 右上, 右下, 左下)
      // (10% 0, 10% 0) 对应左上角的斜切面
      clip-path: polygon(20% 0, 100% 0, 100% 100%, 0 100%, 0 100%);
      border-radius: 6px;

      // 内部内容整体往右移，避免靠近切角
      .card-content {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
      }
    }
  }

  .section {
    margin-bottom: 25px;

    .section-title {
      font-size: 16px;
      margin-bottom: 15px;
    }
  }

  // 节点选择项
  .node-types {
    display: flex;
    gap: 10px;

    .node-item {
      flex: 1;
      background: @card-dark;
      padding: 12px 5px;
      border-radius: 8px;
      text-align: center;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid transparent;
      cursor: pointer;

      .radio-circle {
        width: 14px;
        height: 14px;
        border: 1px solid #555;
        border-radius: 50%;
        margin-right: 6px;
      }

      &.active {
        border-color: @primary-cyan;

        .radio-circle {
          background-color: @primary-cyan;
          border-color: @primary-cyan;
          position: relative;

          &::after {
            content: '✓';
            font-size: 10px;
            color: #fff;
            position: absolute;
            top: -1px;
            left: 2px;
          }
        }
      }
    }
  }

  // 支付区域
  .pay-input-wrapper {
    background: @card-dark;
    border-radius: 8px;
    padding: 9px 13px;

    .pay-inner {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .pay-icon {
        width: 18px;
        height: 18px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .vrt-icon {
        background: #00bcd4;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: inline-block;
        text-align: center;
        line-height: 20px;
        font-size: 12px;
      }

      .pay-amount {
        font-size: 14px;
      }
    }
  }

  .balance-info {
    margin-top: 10px;
    font-size: 12px;
    color: @text-gray;
    text-align: right;
    display: flex;
    justify-content: space-between;
  }

  .upgrade {
    padding: 0 65px;

    // 按钮
    .upgrade-btn {
      width: 100%;
      background: #1B9EB3;
      color: white;
      border: none;
      padding: 8px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 700;
      margin: auto;
    }
  }


  // 底部记录表格
  .record-container {
    border-top: 4px solid #232B3E;
    margin-top: 39px;
    padding-top: 20px;

    .tabs {
      display: flex;
      gap: 30px;
      margin-bottom: 20px;

      .tab {
        color: @text-gray;
        font-size: 16px;
        padding-bottom: 5px;

        &.active {
          color: #fff;
          border-bottom: 2px solid @primary-cyan;
        }
      }
    }

    .table-wrapper {
      background: #232B3E;
      border-radius: 10px;

      .record-table {
        width: 100%;
        border-collapse: collapse;

        thead {
          border-bottom: 1px solid #323C54;
        }

        tr {
          display: flex;
          justify-content: space-between;
          padding: 8px 15px;
        }

        th {
          color: @text-gray;
          font-size: 12px;
          text-align: left;
          font-weight: normal;
          display: flex;
          align-items: center;
          flex: 1;
        }

        td {
          font-size: 13px;
          display: flex;
          align-items: center;
          flex: 1;
        }
      }
    }
  }
}

.popup {
  display: flex;
  flex-direction: column;
  align-items: center;

  .pop_title {
    font-size: 14px;
    font-weight: 700;
    color: #666666;
  }

  .pop_num {
    color: #000000;
    font-weight: 500;
  }

  .pop_wallet {
    display: flex;
    color: #666666;
    font-size: 14px;
    align-items: center;
  }

  .button_box1 {
    width: 100%;
    margin-top: 136px;

    button {
      width: 100%;
      height: 36px;
      border: none;
      border-radius: 2px;
      background: linear-gradient(180deg, #1AD9F3 0%, #2A88CC 100%);
      border-radius: 2px;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>